export type ContactFilterMode = 'list' | 'final';

export function getConsentFilter(isEmailMessageType: boolean, mode: ContactFilterMode = 'list'): string {
  if (mode === 'final') {
    return isEmailMessageType
      ? `ISNULL(Email, '') != '' AND ISNULL(CASE WHEN ce.[Email] IS NULL THEN c.[Consent_Email] ELSE ce.[Consent_Email] END, 1) = 1 AND ce.[Bounced] = 0`
      : `ISNULL(Mobile, '') != '' AND ISNULL(CASE WHEN cm.[Mobile] IS NULL THEN c.[Consent_SMS] ELSE cm.[Consent_SMS] END, 1) = 1`;
  }

  return isEmailMessageType
    ? `ISNULL(Email, '') != '' AND ISNULL(Consent_Email, 1) = 1 AND Bounced = 0`
    : `ISNULL(Mobile, '') != '' AND ISNULL(Consent_SMS, 1) = 1`;
}

export function appendFilterClause(baseFilter: string, clause: string): string {
  const filter = baseFilter || '';

  if (!clause || filter.indexOf(clause) !== -1) {
    return filter;
  }

  return filter.length === 0 ? clause : `${filter} AND (${clause})`;
}

export function appendConsentFilter(baseFilter: string, isEmailMessageType: boolean, mode: ContactFilterMode = 'list'): string {
  return appendFilterClause(baseFilter, getConsentFilter(isEmailMessageType, mode));
}

export function appendExcludedEmails(baseFilter: string, excludedEmailsString?: string): string {
  const filter = baseFilter || '';

  if (!excludedEmailsString || excludedEmailsString.length === 0) {
    return filter;
  }

  return filter.length > 0 ? `(${filter}) AND ${excludedEmailsString}` : excludedEmailsString;
}

export function buildListContactFilter(
  baseFilter: string,
  isEmailMessageType: boolean,
  excludedEmailsString?: string
): string {
  const withConsent = appendConsentFilter(baseFilter, isEmailMessageType, 'list');
  return appendExcludedEmails(withConsent, excludedEmailsString);
}

export function buildFinalContactsFilter(baseFilter: string, isEmailMessageType: boolean): string {
  return appendConsentFilter(baseFilter, isEmailMessageType, 'final');
}
